import { render } from "./ThePositionEditResultDialog.vue?vue&type=template&id=831fc016&ts=true"
import script from "./ThePositionEditResultDialog.vue?vue&type=script&lang=ts"
export * from "./ThePositionEditResultDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__